import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { customStyles } from '../../components/ui/Select';

const StateMunicipalityDropdown = ({ data, selectedMunicipality, setSelectedMunicipality }) => {
  const [selectedState, setSelectedState] = useState(null);
  const [showMunicipalityDropdown, setShowMunicipalityDropdown] = useState(false);

  useEffect(() => {
    if (selectedMunicipality) {
      const stateOfSelectedMunicipality = data.find((state) =>
        state.children.some((municipality) => municipality.value === selectedMunicipality)
      );

      if (stateOfSelectedMunicipality) {
        setSelectedState({ value: stateOfSelectedMunicipality.value, label: stateOfSelectedMunicipality.label });
        setShowMunicipalityDropdown(true);
        setSelectedMunicipality(selectedMunicipality);
      }
    }
  }, [data, selectedMunicipality]);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setShowMunicipalityDropdown(true);
    setSelectedMunicipality(null);
  };

  const handleBackButtonClick = () => {
    setSelectedState(null);
    setShowMunicipalityDropdown(false);
    setSelectedMunicipality(null);
  };

  const stateOptions = data.map((state) => ({
    value: state.value,
    label: state.label,
  }));

  const selectedStateData = selectedState
    ? data.find((state) => state.value === selectedState.value)
    : null;

  const municipalityOptions = selectedStateData
    ? selectedStateData.children.map((municipality) => ({
        value: municipality.value,
        label: municipality.label,
      }))
    : [];

  return (
    <div>
      <div className={`${showMunicipalityDropdown ? 'tw-hidden' : ''}`}>
        <Select
          options={stateOptions}
          onChange={handleStateChange}
          placeholder="Select a state"
          styles={customStyles}
          value={selectedState}
        />
      </div>
      <div className={`${showMunicipalityDropdown ? '' : 'tw-hidden'}`}>
        <Select
          options={municipalityOptions}
          placeholder="Select a county"
          styles={customStyles}
          onChange={setSelectedMunicipality}
          value={selectedMunicipality !== null ? municipalityOptions.find((option) => option.value === selectedMunicipality) : null}
        />
        <div
          onClick={handleBackButtonClick}
          className="tw-flex tw-items-center tw-gap-2 tw-mt-2 tw-cursor-pointer tw-text-sm tw-text-primary-600 hover:tw-text-primary-700 tw-transition-colors"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          {selectedState && (
            <span className="tw-font-medium">State: {selectedState.label}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default StateMunicipalityDropdown;
